import { isNull } from "lodash-es";

export function getUrlParam(_paramName: any, _url?: any) {
    const reg = new RegExp(`(^|&)${_paramName}=([^&]*)(&|$)`, 'i');
    let url = _url || window.location.href;

    if (url && url.replace) {
        url = url.replace('#/', '').toString();
        const r = ((url ? url.split('?')[1] : encodeURI(window.location.search).substr(1)) || '').match(
            reg,
        );
        if (!isNull(r)) return unescape(r[2]);
    }

    return null;
}